import type { Job } from '@core/types';

/** Fields extracted from JD by `ggj_b2b_smart_match` extract-jd and stored on `jd_structured_json`. */
export function readJdTaxonomyFromJob(job: Pick<Job, 'jd_structured_json'>): {
  category: string | null;
  seniority: string | null;
  industry: string | null;
} {
  const raw = job.jd_structured_json;
  if (!raw || typeof raw !== 'object') {
    return { category: null, seniority: null, industry: null };
  }
  const o = raw as Record<string, unknown>;
  return {
    category: typeof o.job_category === 'string' && o.job_category.trim() ? o.job_category.trim() : null,
    seniority:
      typeof o.seniority_level === 'string' && o.seniority_level.trim() ? o.seniority_level.trim() : null,
    industry:
      typeof o.client_industry === 'string' && o.client_industry.trim() ? o.client_industry.trim() : null,
  };
}

export function jdTaxonomySummaryLine(job: Pick<Job, 'jd_structured_json'>): string | null {
  const { category, seniority, industry } = readJdTaxonomyFromJob(job);
  const parts = [category, seniority, industry].filter(Boolean) as string[];
  return parts.length ? parts.join(' · ') : null;
}
